import React, { useMemo, useState, useEffect } from 'react';
import styled from 'styled-components';
import { PFileList, PFileItem } from '../../sidebar';
const iconExport = '/assets/images/icon/Icon_Export.svg';
const ArrowRightIcon = '/assets/images/arrow/arrow_right_up.svg';

interface Props {
  linkSet?: any;
  caseInfo?: any;
  setShowFileModal?: React.Dispatch<React.SetStateAction<boolean>>;
  disabled?: boolean;
}

const PAttachmentFile = ({ linkSet, setShowFileModal, disabled }: Props) => {
  const fileButtons: PFileItem[] = useMemo(
    () => [
      {
        content: '재산명세서',
        icon: 'invoice.svg',
        link: linkSet?.buttonLink?.propertyStat || '',
        disabled: !linkSet?.buttonLink?.propertyStat,
      },
      {
        content: '감정평가서',
        icon: 'search.svg',
        link: linkSet?.buttonLink?.appraisal || '',
        disabled: !linkSet?.buttonLink?.appraisal,
      },
      {
        content: '건물등기',
        icon: 'building.svg',
        link: linkSet?.buttonLink?.buildingRegister || '',
        disabled: !linkSet?.buttonLink?.buildingRegister,
      },
      {
        content: '토지등기',
        icon: 'layer.svg',
        link: linkSet?.buttonLink?.landRegister || '',
        disabled: !linkSet?.buttonLink?.landRegister,
      },
      {
        content: '압류재산정보',
        icon: 'lock.svg',
        link: linkSet?.buttonLink?.assetDetail || '',
        disabled: !linkSet?.buttonLink?.assetDetail,
      },
    ],
    [linkSet],
  );

  return (
    <div>
      <DetailContainer>
        <TitleWrapper>
          <AttchmentTitle>첨부파일</AttchmentTitle>
          <ExportButton onClick={() => setShowFileModal?.(true)}>
            일괄 내보내기
            <img src="/assets/images/icon/download-black.svg" alt="" />
          </ExportButton>
        </TitleWrapper>
        <ContentWrapper>
          {fileButtons.map((item, idx) => {
            const isDisabled = item.disabled ?? !item.link;

            const handleClick = () => {
              if (item.isModal) {
                setShowFileModal?.(true);
                return;
              }
              if (isDisabled) return;
              window.open(item.link, '_blank');
            };

            return (
              <ContentBox
                key={idx}
                onClick={handleClick}
                style={{
                  opacity: isDisabled ? 0.2 : 1,
                  pointerEvents: isDisabled ? 'none' : 'auto',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                }}
              >
                {item.content}
                <img
                  src="/assets/images/arrow/arrow-up-black.svg"
                  alt=""
                  style={{ transform: 'rotate(90deg)' }}
                />
              </ContentBox>
            );
          })}
        </ContentWrapper>
        <ContentWrapper
          style={{ marginTop: '24px', paddingTop: '8px', paddingBottom: '8px' }}
        >
          <ContentBox2
            onClick={() => {
              window.open(linkSet.detailLink.url);
            }}
          >
            온비드 공매 이동
            <img src={ArrowRightIcon} alt="" />
          </ContentBox2>
        </ContentWrapper>
      </DetailContainer>
    </div>
  );
};

export default PAttachmentFile;
const DetailContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding: 32px 16px;
  background-color: #ffffff;
`;

const AttchmentTitle = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  gap: 24px;
  color: #222222;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;

const ExportButton = styled.button`
  border: none;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const ContentWrapper = styled.div`
  padding-left: 16px;
  padding-right: 8px;
  border-radius: 8px;
  background-color: #f7f8fc;
`;

const ContentBox = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #f3f5f7;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ContentBox2 = styled.div`
  padding: 12px 0;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
  cursor: pointer;
  padding: 0;
  color: #004e97;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
